import { FilterOutlined, SearchOutlined } from "@ant-design/icons";
import { Button, Input, Select, Tag } from "antd";
import LayoutTableV2 from "app/components/TableV2";
import {
  CSoftInventoryList,
  CURRENCY,
  EInventoryBuildingClass,
  EInventoryLabel,
  EInventoryRentalArea,
  EInventorySpaceType,
  EMPTY_VALUE,
  ESoftInventoryList,
} from "constant";
import { PAGE_ROUTE } from "constant/routes/page";
import { useGetParamsUrl, useHandleSubmitApi } from "hook";
import { IBaseGetDataForPaginate, IGetInventoryOutputModel } from "interfaces";
import { IGetInventoryInputModel } from "interfaces/inventory/api";
import { TDistrictOutputModel, TProvinceOutputModel } from "interfaces/province";
import _ from "lodash";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { createSearchParams, useNavigate } from "react-router-dom";
// import { ProvinceService } from "services";
import moment from "moment";
import { InventoryServices } from "services/inventory";
import { DivisionUtils } from "utils/division";
import { OtherUtil } from "utils/other";
import InventoryFilter from "./InventoryFilter";

type P_Props = {};

enum EQueryString {
  PAGE_NUM = "pageNum",
  PAGE_SIZE = "pageSize",
  CODE = "code",
}

const InventoryListPresenter = (props: P_Props) => {
  const navigate = useNavigate();
  const { t } = useTranslation("translation");
  const { search, pathname } = window.location;
  const dataParams: any = useGetParamsUrl(search);

  const [list, setList] = useState<IGetInventoryOutputModel[]>([]);
  const [provinces, setProvinces] = useState<TProvinceOutputModel[]>([]);
  const [districts, setDistricts] = useState<TDistrictOutputModel[]>([]);

  const [visibleFilter, setVisibleFilter] = useState(false);
  const [filter, setFilter] = useState<Partial<IGetInventoryInputModel>>({
    searchValue: "",
    provinceCode: null,
    districtCodes: [],
    buildingClasses: Object.keys(EInventoryBuildingClass) as EInventoryBuildingClass[],
    spaceTypes: Object.keys(EInventorySpaceType) as EInventorySpaceType[],
    rentalAreas: Object.keys(EInventoryRentalArea) as EInventoryRentalArea[],
    labels: Object.keys(EInventoryLabel) as EInventoryLabel[],
    priceFrom: 0,
    priceTo: 100,
  });
  const [selectedSort, setSelectedSort] = useState<keyof typeof ESoftInventoryList>(ESoftInventoryList["LASTED"]);

  const [totalRecord, setTotalRecord] = useState<number>(0);
  const [pageNum, setPageNum] = useState<number>(1);
  const [pageSize, setPageSize] = useState<number>(10);

  useEffect(() => {
    handleFetchCity();
    handleFetchInventories();
    //eslint-disable-next-line
  }, []);

  // useEffect(() => {
  //   if (!dataParams || !dataParams?.code || !filter["provinceCode"]) return;
  //   handleFetchDistrict(filter["provinceCode"] || dataParams?.code);

  //   // eslint-disable-next-line
  // }, [dataParams?.code, filter["provinceCode"]]);

  useEffect(() => {
    // if (!districts || !districts.length || !dataParams) return;

    handleFetchInventories();
    // eslint-disable-next-line
  }, [selectedSort, pageNum, districts, pageSize]);

  useEffect(() => {
    if (!_.isEmpty(dataParams)) {
      if (dataParams[EQueryString.CODE]) {
        handleFetchDistrict(filter["provinceCode"] || dataParams?.code);
      }

      if (dataParams[EQueryString.PAGE_NUM]) {
        setPageNum(+dataParams[EQueryString.PAGE_NUM]);
      }

      if (dataParams[EQueryString.PAGE_SIZE]) {
        setPageSize(+dataParams[EQueryString.PAGE_SIZE]);
      }

      sessionStorage.setItem("filter", search);
    }

    // eslint-disable-next-line
  }, [dataParams, search]);

  const handleFetchCity = async (cateId?: number) => {
    const listProvinces = DivisionUtils.getProvinces();
    const filterProvinceByCode = [1, 48, 79];
    const provincesFilter = listProvinces.filter((p) => filterProvinceByCode.includes(p.code));
    setProvinces(provincesFilter);

    if (pathname === PAGE_ROUTE.ADM_INVENTORY) {
      // const code = cateId ?? provincesFilter[0].code;
      // onChangeQueryString({ [EQueryString.CODE]: code });
      // activeCate(cateId ?? provincesFilter[0].code);
      // handleChangeFilter({ provinceCode: cateId || provincesFilter[0].code });
    }
  };

  const handleFetchDistrict = async (provinceCode: string | number) => {
    handleChangeFilter({ districtCodes: [] });
    try {
      const districts = DivisionUtils.getDistricts(+provinceCode || 1);
      setDistricts(districts);
      // handleChangeFilter({ districtCodes: districts.map((d) => d.code) }, true);
    } catch (error) {
      OtherUtil.loadError(error);
    }
  };

  const [handleFetchInventories, loadingPaginate] = useHandleSubmitApi(
    async (iFilter?: Partial<IGetInventoryInputModel>) => {
      const sortOpt = handleSort(selectedSort);
      let input: IGetInventoryInputModel = {
        sortBy: sortOpt?.sortBy || "createdAt",
        sortOrder: sortOpt?.sortOrder || "desc",
        pageNum: pageNum,
        pageSize: pageSize,
        ...filter,
      };
      if (iFilter) {
        input = { ...input, ...iFilter };
      }

      if (
        !!input?.buildingClasses?.length &&
        input.buildingClasses.length === Object.keys(EInventoryBuildingClass).length
      ) {
        input.buildingClasses = [];
      }

      if (!!input?.rentalAreas?.length && input.rentalAreas.length === Object.keys(EInventoryRentalArea).length) {
        input.rentalAreas = [];
      }

      if (!!input?.spaceTypes?.length && input.spaceTypes.length === Object.keys(EInventorySpaceType).length) {
        input.spaceTypes = [];
      }

      if (!!input?.labels?.length && input.labels.length === Object.keys(EInventoryLabel).length) {
        input.labels = [];
      }

      const dataRes = await InventoryServices.getInventoriesPaginate(input);
      if (dataRes) {
        setList(dataRes.data);

        if (dataRes.meta) {
          const { totalRecords } = dataRes.meta;
          setTotalRecord(totalRecords);
          // setPageNum(pageNum);
          // onChangeQueryString({ [EQueryString.PAGE_NUM]: pageNum, [EQueryString.PAGE_SIZE]: pageSize });
        }
      }
    }
  );

  const handleSort = (
    key: keyof typeof ESoftInventoryList | null
  ): Pick<IBaseGetDataForPaginate, "sortBy" | "sortOrder"> | null => {
    if (!key) return null;
    return (CSoftInventoryList as any)[key] || null;
  };

  const handleChangeFilter = (value: Partial<IGetInventoryInputModel>, isQuery?: boolean) => {
    const cFilters = { ...filter, ...value };
    setFilter(cFilters);

    if (isQuery) {
      handleFetchInventories(cFilters);
    }
  };

  const handleApplyFilter = () => {
    handleFetchInventories();
  };

  const onChangeQueryString = (params: any) => {
    navigate({
      pathname: PAGE_ROUTE.ADM_INVENTORY,
      search: createSearchParams({
        ...dataParams,
        ...params,
      }).toString(),
    });
  };

  return (
    <>
      <InventoryFilter
        visible={visibleFilter}
        options={{
          provinces,
          districts,
        }}
        onClose={() => setVisibleFilter(false)}
        onApply={handleApplyFilter}
        filter={filter}
        onChangeValue={handleChangeFilter}
      />

      <LayoutTableV2<IGetInventoryOutputModel>
        loading={loadingPaginate}
        onClick={(record) => {
          navigate({
            pathname: PAGE_ROUTE.ADM_INVENTORY_EDIT,
            search: createSearchParams({
              id: record.id,
            }).toString(),
          });
        }}
        header={() => (
          <React.Fragment>
            <div className="layout-list__header__menu" style={{ width: "20rem" }}>
              <Select
                showSearch
                size="large"
                placeholder="Sắp xếp"
                optionFilterProp="children"
                onChange={setSelectedSort}
                value={selectedSort}
                filterOption={(input, option) => (option?.label ?? "").toLowerCase().includes(input.toLowerCase())}
                className="w_100"
                options={Object.keys(CSoftInventoryList).map((key) => ({ label: t(key), value: key }))}
              />
            </div>
            <div className="d-flex">
              <Input
                placeholder="Nhập thông tin tìm kiếm"
                className="mr_1"
                suffix={<SearchOutlined />}
                onChange={_.debounce((e) => {
                  handleChangeFilter({ searchValue: e.target.value, pageNum: 1 }, true);
                }, 500)}
                // value={searchValue}
              />
              <Button size="large" className="mr_1" onClick={() => setVisibleFilter(true)}>
                <FilterOutlined />
                Bộ lọc
              </Button>
              <Button className="btn" size="large" onClick={() => navigate(PAGE_ROUTE.ADM_INVENTORY_CREATE)}>
                + Thêm toà nhà
              </Button>
            </div>
          </React.Fragment>
        )}
        // loading={loading}
        data={list.map((value) => ({
          key: value.id,
          id: value.id,
          title: value.title,
          buildingClass: value.buildingClass ? t(value.buildingClass) : EMPTY_VALUE,
          spaceTypeBuilding: value.spaceTypeBuilding ? t(value.spaceTypeBuilding) : EMPTY_VALUE,
          price: `${value.priceFrom + CURRENCY} - ${value.priceTo + CURRENCY}`,
          investorName: value.investorName || EMPTY_VALUE,
          isShow: value.isShow,
          createdAt: value.createdAt ? moment(value.createdAt).format("DD/MM/YYYY HH:mm:ss") : EMPTY_VALUE,
        }))}
        columns={[
          {
            title: "Tiêu đề",
            dataIndex: "title",
            key: "title",
            fixed: "left",
          },
          {
            title: "Hạng toà nhà",
            dataIndex: "buildingClass",
            key: "buildingClass",
            fixed: "left",
          },
          { title: "Loại hình không gian", dataIndex: "spaceTypeBuilding", key: "spaceTypeBuilding" },
          { title: "Giá sản phẩm", dataIndex: "price", key: "price" },
          { title: "Chủ đầu tư", dataIndex: "investorName", key: "investorName" },
          {
            title: "Trạng thái",
            dataIndex: "isShow",
            key: "isShow",
            render: (value) => {
              let data = {
                color: "green",
                title: "Hiển thị",
              };
              if (!value) {
                data = {
                  color: "magenta",
                  title: "Ẩn",
                };
              }
              return <Tag color={data.color}>{data.title}</Tag>;
            },
          },
          {
            title: "Thời gian tạo",
            dataIndex: "createdAt",
            key: "createdAt",
          },
        ]}
        optionPaginate={{
          numberRecordShow: list.length,
          totalRecord: totalRecord,
          pageNum: pageNum,
          pageSize: pageSize,
          onChangePageNum: (pageNum: number, pageSize: number) => {
            console.log(315, { pageNum, pageSize });
            onChangeQueryString({ [EQueryString.PAGE_NUM]: pageNum, [EQueryString.PAGE_SIZE]: pageSize });
          },
          title: "toà nhà",
        }}
      />
    </>
  );
};

export default InventoryListPresenter;
